import styles from './index.module.less';
import { build, image_fill, water } from '@shared/assets/svg/base';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import classNames from 'classnames';

interface Props {
	type: 'app' | 'img' | 'water';
	text: string;
	className?: string;
}

const ICON_MAP = {
	app: build,
	img: image_fill,
	water: water,
};
export const BaseEmpty = (props: Props) => {
	const { type, text, className } = props;

	return (
		<div className={classNames(styles.container, className)}>
			<NewBaseIcon size={60} icon={ICON_MAP[type]} />
			<span>{text}</span>
		</div>
	);
};
